<template>
    <div class="col-lg-4">
        <div class="fixed-block">
            <div class="summary-block">
                <div class="box">
                    <div class="box-offset">
                        <div class="row align-items-center">
                            <div class="col-6">
                                <h3 class="mb-0">Summary</h3>
                            </div>
                            <div class="col-6 text-right">
                                <a :href="`/products/${boat.slug}`" class="link">Change Details</a>
                            </div>
                        </div>

                        <div class="separation-small"></div>
                        <div class="rented-boat-details-wrap">
                            <div class="rented-boat-details">
                                <a :href="`/products/${boat.slug}`" class="prod-link">
                                    <img :src="boat.image" alt="">
                                </a>
                                <div >
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="rented-time">{{ order.duration }} hours</div>
                                        </div>
                                        <div class="col-6 text-right">
                                            <div class="ammount">${{ order.price }}</div>
                                        </div>
                                        <div class="col-12 mt-3">
                                            <h6>{{ boat.name }}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <small class="mb-4">Rate includes FL sales tax and credit card processing fee.</small>
                            <div class="d-flex">
                                <i class="fas fa-map-marker-alt"></i>
                                <div>
                                    <strong>Pick Up:</strong> <br/>
                                    <p>{{ location.name }}</p>
                                </div>
                            </div>
                            <div class="d-flex">
                                <i class="fas fa-calendar-alt"></i>
                                <div>
                                    <p>{{ order.starts_at_formatted }}</p>
                                </div>
                            </div>
                        </div>

                        <template v-if="addons.length">
                            <div class="separation-small"></div>
                            <h6>Appointment</h6>
                            <div class="d-flex mb-4" v-for="addon in addons" :key="addon.id">
                                <i class="fas fa-check"></i>
                                <div>
                                    <p>{{ addon.description }}</p>
                                </div>
                            </div>
                        </template>

                        <div class="separation-small"></div>
                        <h6>Add Coupon</h6>
                        <form class="promocode-input" action="#" method="post">
                            <input type="text" placeholder="Enter Promo Code" class="form-control" v-model="promoCode">
                            <button type="submit" @click.prevent="submitPromo">Apply</button>
                        </form>

                        <div class="separation"></div>

                        <div class="total-cost">
                            <div class="row">
                                <div class="col-6 ">
                                    <p>Subtotal:</p>
                                </div>
                                <div class="col-6 text-right">
                                    <p>
                                        {{ subTotal | toFixed | toUSD }}
                                    </p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6 ">
                                    <p>Discount:</p>
                                </div>
                                <div class="col-6 text-right">
                                    <p>
                                        {{ getDiscount | toFixed | toUSD }}
                                    </p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6 ">
                                    <p>Taxes & Fees:</p>
                                </div>
                                <div class="col-6 text-right">
                                    <p>
                                        {{ getTaxes | toFixed | toUSD }}
                                    </p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6 ">
                                    <p>Total:</p>
                                </div>
                                <div class="col-6 text-right">
                                    <p>
                                        <strong>
                                            {{ total | toFixed | toUSD }}
                                        </strong>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <a class="btn w-100" href="javascript:void(0)" @click="pay">
                            <em>{{ total | toUSD }}</em>
                            <strong>{{ continueButtonText }}</strong>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import promoCode from "../../../../../../resources/js/mixins/promo-code";
    import swalMessages from "../../../../../../resources/js/mixins/swal-messages";
    import { mapGetters } from "vuex";

    export default {
        name: "PaymentSummary",
        mixins: [ promoCode, swalMessages ],
        props: {
            boat: {
                type: Object
            },
            order: {
                type: Object
            }
        },
        data() {
            return {
                location: { ...this.order.location },
                addons: [...this.order.addons ],
                total: this.order.total,
                subTotal: this.order.subTotal,
                promo: this.order.promo ? this.order.promo : null,
                promoCode: this.order.promo ? this.order.promo.name : null,
                taxes: {
                    amount: 10,
                    type: 'PERCENTAGE'
                },
            }
        },
        computed: {
            ...mapGetters({
                paymentType: 'GET_PAYMENT_TYPE'
            }),

            continueButtonText() {
                return this.paymentType === 'pay_with_cash' ? 'book now' : 'pay now';
            },
            getDiscount() {
                const promoAmount = this.promo?.amount || 0;

                return (this.subTotal * promoAmount / 100);
            },
            getSubtotalWithDiscount() {
                return this.subTotal - this.getDiscount;
            },
            getTaxes() {
                return this.taxes.type === 'PERCENTAGE' &&
                    (this.getSubtotalWithDiscount * this.taxes.amount / 100);
            },
            promoCodeUsed() {
                return this.promoCode.toUpperCase() === this.promo.name
            }
        },
        methods: {
            submitPromo() {
                if (this.promoCodeUsed) this.showErrorMessage('Your promo code has already been used!');
                if (!this.promoCodeUsed) this.submitPromoCode();
            },
            pay() {
                this.$root.$refs.paymentMethod.validate()
            }
        }
    }
</script>

<style scoped>
    .boat-inner-page .summary-block .total-cost strong {
        font-size: 1.25rem;
    }
</style>
